export const loadDynamicScript = (
  id: string,
  src: string,
  cb = (): unknown => {},
): void => {
  const existingScript = document.getElementById(id)

  if (!existingScript) {
    const script = document.createElement('script')
    const headTag = document.getElementsByTagName('head')[0]
    script.async = true
    script.id = id
    script.src = src

    script.onerror = (): Error => cb(new Error('Failed to load' + src))
    script.onload = (): unknown => cb()

    headTag?.appendChild(script)
  }

  if (existingScript && cb) {
    cb()
  }
}
